var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-inline-block" },
    [
      _vm.purchase.flags.is_first_contract === false
        ? [
            _vm.purchase.restrictions.second_contract_supplier_money.status
              ? [
                  _c(
                    "b-btn",
                    {
                      attrs: {
                        id: "contract-not-enough",
                        disabled: !_vm.$store.getters.getCanSign,
                        variant: "custom-green",
                      },
                    },
                    [_vm._v("Подписать и отправить контракт")]
                  ),
                  _c(
                    "b-popover",
                    {
                      attrs: {
                        target: "contract-not-enough",
                        triggers: "hover",
                      },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "fs-12 my-1 py-1" },
                        [
                          _vm._v(" Необходимо для блокировки "),
                          _c("span", { staticClass: "fw-600 text-nowrap" }, [
                            _vm._v(
                              _vm._s(_vm.$formatPrice(_vm.purchase.fee_amount))
                            ),
                          ]),
                          _vm._v(" руб. "),
                          _c("br"),
                          _vm._v(" Для подписания контракта не хватает "),
                          _c(
                            "span",
                            { staticClass: "text-danger fw-600 text-nowrap" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$formatPrice(
                                    _vm.purchase.restrictions
                                      .second_contract_supplier_money.not_enough
                                  )
                                )
                              ),
                            ]
                          ),
                          _vm._v(" руб."),
                          _c("br"),
                          _c(
                            "router-link",
                            {
                              staticClass: "system_link-style",
                              attrs: { to: { name: "CabinetAccounting" } },
                            },
                            [_vm._v("Пополнить лицевой счет")]
                          ),
                          _vm._v(" . "),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              : [
                  _c(
                    "b-btn",
                    {
                      attrs: {
                        id: "sign-contract-button",
                        disabled: !_vm.$store.getters.getCanSign,
                        variant: "custom-green",
                      },
                      on: { click: _vm.showSignForm },
                    },
                    [_vm._v("Подписать и отправить контракт")]
                  ),
                  _c(
                    "b-popover",
                    {
                      attrs: {
                        target: "sign-contract-button",
                        triggers: "hover",
                        placement: "top",
                      },
                    },
                    [
                      _c("p", { staticClass: "fs-12 my-1 py-1" }, [
                        _c(
                          "span",
                          { staticClass: "text-danger" },
                          [
                            _c("b-icon-exclamation-triangle-fill"),
                            _vm._v(" Внимание!"),
                          ],
                          1
                        ),
                        _c("br"),
                        _vm._v(
                          " На лицевом счете Вашей организации, в соответствии с Регламентом, будет заблокирована сумма "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$formatPrice(_vm.purchase.fee_amount))
                          ),
                        ]),
                        _vm._v(" руб. "),
                      ]),
                    ]
                  ),
                ],
          ]
        : _c(
            "b-overlay",
            {
              attrs: {
                show: _vm.isDataSending,
                rounded: "",
                opacity: "0.6",
                "spinner-small": "",
                "spinner-variant": "primary",
              },
            },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    disabled: !_vm.$store.getters.getCanSign,
                    variant: "custom-green",
                  },
                  on: { click: _vm.showSignForm },
                },
                [_vm._v("Подписать и отправить контракт")]
              ),
            ],
            1
          ),
      !_vm.$store.getters.getCanSign
        ? [
            _vm.$store.getters.getLoginType === "cert"
              ? _c(
                  "span",
                  { staticClass: "text-danger pl-3 pt-0 fs-14 w-50 my-auto" },
                  [
                    _vm._v(
                      "Для действия требуется загрузить/заменить МЧД на странице: "
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "green-link",
                        attrs: { to: { name: "CabinetUserProfile" } },
                      },
                      [_vm._v("Данные учетной записи")]
                    ),
                  ],
                  1
                )
              : _c(
                  "span",
                  { staticClass: "text-danger pl-3 pt-0 fs-14 w-50 my-auto" },
                  [
                    _vm._v(
                      "Подписание возможно только при авторизации при помощи ЭЦП"
                    ),
                  ]
                ),
          ]
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "sign-form-modal",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            scrollable: "",
            size: "lg",
            title: "Подписать и отправить контракт",
          },
          on: { close: _vm.cancelSignModal },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function () {
                return [_c("button-close-modal")]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showSignModal,
            callback: function ($$v) {
              _vm.showSignModal = $$v
            },
            expression: "showSignModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-block text-left" },
            [
              _c(
                "b-tabs",
                { attrs: { "content-class": "mt-3 px-3" } },
                [
                  _c(
                    "b-tab",
                    {
                      attrs: { active: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "system_link-style fs-16" },
                                [_vm._v("Данные закупки")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v("Информация о заказчике"),
                      ]),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          label: "Наименование организации",
                          value: _vm.purchase.contract.customer.name,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          label: "ИНН",
                          value: _vm.purchase.contract.customer.inn,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          label: "КПП",
                          value: _vm.purchase.contract.customer.kpp,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          label: "ОГРН",
                          value: _vm.purchase.contract.customer.ogrn,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          label: "Адрес",
                          value: _vm.purchase.contract.customer.legal_address,
                        },
                      }),
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v("Информация о поставщиике"),
                      ]),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          label: "Наименование организации",
                          value: _vm.purchase.contract.supplier.name,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          label: "ИНН",
                          value: _vm.purchase.contract.supplier.inn,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          label: "КПП",
                          value: _vm.purchase.contract.supplier.kpp,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          label: "ОГРН",
                          value: _vm.purchase.contract.supplier.ogrn,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          label: "Адрес",
                          value: _vm.purchase.contract.supplier.legal_address,
                        },
                      }),
                      _c("hr"),
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v("Условия закупки"),
                      ]),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Объект закупки",
                          value: _vm.purchase.purchase_terms.purchase_object,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Предмет закупки",
                          value:
                            _vm.purchase.purchase_terms.deliverable_group.name,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Тип закупки",
                          value: _vm.purchase.purchase_terms.order_type.name,
                        },
                      }),
                      _c("text-row-price", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Цена контракта",
                          value: _vm.purchase.purchase_terms.contract_price,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Продолжительность закупочной сессии",
                          value: _vm.purchase.purchase_terms.duration_type.name,
                        },
                      }),
                      _c("text-row-boolean-text", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Аванс",
                          value: _vm.purchase.purchase_terms.with_advance,
                        },
                      }),
                      _vm.purchase.purchase_terms.with_advance
                        ? _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Размер аванса",
                              value:
                                _vm.purchase.purchase_terms.advance_percentage +
                                "%",
                            },
                          })
                        : _vm._e(),
                      _c("text-row-date", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Планируемая дата заключения договора",
                          value:
                            _vm.purchase.purchase_terms
                              .planned_contract_conclusion_date,
                        },
                      }),
                      _c("text-row-date", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Планируемая дата исполнения договора",
                          value:
                            _vm.purchase.purchase_terms
                              .planned_contract_execution_date,
                        },
                      }),
                      _c("text-row-single-document", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Проект ГК",
                          value:
                            _vm.purchase.purchase_terms
                              .contract_draft_attachment,
                        },
                      }),
                      _vm.purchase.purchase_terms
                        .commercial_proposal_form_attachment
                        ? _c("text-row-single-document", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label:
                                "Образец коммерческого предложения для заполнения",
                              value:
                                _vm.purchase.purchase_terms
                                  .commercial_proposal_form_attachment,
                            },
                          })
                        : _vm._e(),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label:
                            "Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации",
                          value:
                            _vm.purchase.purchase_terms
                              .unilateral_contract_termination_info,
                          "text-wrap": "",
                        },
                      }),
                      _vm.purchase.delivery_terms.addresses.length > 0 ||
                      _vm.purchase.delivery_terms.schedule
                        ? [
                            _c("hr"),
                            _c("h4", { staticClass: "font-weight-bold" }, [
                              _vm._v("Условия поставки"),
                            ]),
                            _vm.purchase.delivery_terms.addresses.length > 0
                              ? _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      "label-cols-sm": 4,
                                      "label-cols-lg": 4,
                                      label: "Адреса для доставки/самовывоза:",
                                      "label-class":
                                        "fs-14 grey-color fw-700 d-flex align-items-baseline",
                                    },
                                  },
                                  [
                                    _c(
                                      "ul",
                                      _vm._l(
                                        _vm.purchase.delivery_terms.addresses,
                                        function (address, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: index,
                                              staticClass:
                                                "fs-14 grey-color my-auto col-form-label pb-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  index +
                                                    1 +
                                                    ". " +
                                                    address.address ?? address
                                                )
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c("text-row", {
                              attrs: {
                                compact: "",
                                "label-cols-lg": 4,
                                "label-cols-sm": 4,
                                label:
                                  "График поставки товаров (выполнения работ, оказания услуг)",
                                value: _vm.purchase.delivery_terms.schedule,
                                "text-wrap": "",
                              },
                            }),
                          ]
                        : _vm._e(),
                      _c("hr"),
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v("Спецификация"),
                      ]),
                      _vm.purchase.supplier_proposal.deliverables.length > 0
                        ? _c("b-form-group", [
                            _c(
                              "ul",
                              _vm._l(
                                _vm.purchase.supplier_proposal.deliverables,
                                function (item, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      staticClass:
                                        "fs-14 grey-color my-auto col-form-label py-1",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(index + 1 + ".") +
                                          " " +
                                          _vm._s(item.ktru_item.name) +
                                          " - " +
                                          _vm._s(
                                            item.ktru_item.okei_local_symbol
                                          ) +
                                          ": Цена за ед. " +
                                          _vm._s(item.price) +
                                          " руб." +
                                          _vm._s(
                                            _vm.purchase.supplier_proposal
                                              .without_vat
                                              ? ""
                                              : `, ${item.vat.title}`
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                      _vm.purchase.additional_documents.length > 0
                        ? [
                            _c("hr"),
                            _c("h4", { staticClass: "font-weight-bold" }, [
                              _vm._v("Дополнительные документы"),
                            ]),
                            _c("text-row-documents", {
                              attrs: {
                                label: "Дополнительные документы",
                                compact: "",
                              },
                              model: {
                                value: _vm.purchase.additional_documents,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.purchase,
                                    "additional_documents",
                                    $$v
                                  )
                                },
                                expression: "purchase.additional_documents",
                              },
                            }),
                          ]
                        : _vm._e(),
                      _c("hr"),
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v("Требования к участникам закупки"),
                      ]),
                      !_vm.isSignedXml
                        ? [
                            _vm.purchase.supplier_requirements.supplier_reqs_a
                              ? [
                                  _c("form-row-edit-checkbox", {
                                    attrs: {
                                      "label-cols-sm": 11,
                                      "label-cols-lg": 11,
                                      "form-class": "text-right",
                                      v: _vm.$v.form
                                        .supplier_requirements_confirmed
                                        .supplier_reqs_a,
                                      label:
                                        "Подтверждаю, что соответствую требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                                      compact: "",
                                    },
                                    model: {
                                      value:
                                        _vm.form.supplier_requirements_confirmed
                                          .supplier_reqs_a,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form
                                            .supplier_requirements_confirmed,
                                          "supplier_reqs_a",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.supplier_requirements_confirmed.supplier_reqs_a",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-row",
                                      staticStyle: {
                                        "word-break": "break-all",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "fs-14 grey-color my-1",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                "Подтверждаю, что соответствую следующим требованиям"
                                              ),
                                            ]),
                                            _vm._v(
                                              " - " +
                                                _vm._s(
                                                  _vm.purchase
                                                    .supplier_requirements
                                                    .supplier_reqs_a_details
                                                    .supplier_reqs_a_text
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "fs-14 grey-color mt-2 mb-1",
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              "Подтверждаю, что соответствую указанным требованиям, приложив следующие документы:"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._l(
                                    _vm.purchase.supplier_requirements
                                      .supplier_reqs_a_details
                                      .supplier_reqs_a_documents,
                                    function (item, index) {
                                      return _c(
                                        "form-row-single-line-document-upload",
                                        {
                                          key: `supplier_required_document_${index}`,
                                          attrs: {
                                            title: item.name,
                                            v: _vm.$v.form
                                              .supplier_requirements_confirmed
                                              .supplier_required_documents
                                              .$each[index].storedDocument,
                                            "label-cols-lg": 4,
                                            compact: "",
                                          },
                                          model: {
                                            value:
                                              _vm.form
                                                .supplier_requirements_confirmed
                                                .supplier_required_documents[
                                                index
                                              ].storedDocument,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form
                                                  .supplier_requirements_confirmed
                                                  .supplier_required_documents[
                                                  index
                                                ],
                                                "storedDocument",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.supplier_requirements_confirmed.supplier_required_documents[index].storedDocument",
                                          },
                                        }
                                      )
                                    }
                                  ),
                                ]
                              : _vm._e(),
                            _vm.purchase.supplier_requirements.supplier_reqs_b
                              ? _c("form-row-edit-checkbox", {
                                  attrs: {
                                    "label-cols-sm": 11,
                                    "label-cols-lg": 11,
                                    "form-class": "text-right",
                                    v: _vm.$v.form
                                      .supplier_requirements_confirmed
                                      .supplier_reqs_b,
                                    label:
                                      "Подтверждаю, что соответствую требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                                    compact: "",
                                  },
                                  model: {
                                    value:
                                      _vm.form.supplier_requirements_confirmed
                                        .supplier_reqs_b,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form
                                          .supplier_requirements_confirmed,
                                        "supplier_reqs_b",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.supplier_requirements_confirmed.supplier_reqs_b",
                                  },
                                })
                              : _vm._e(),
                            _vm.purchase.supplier_requirements.supplier_reqs_c
                              ? _c("form-row-edit-checkbox", {
                                  attrs: {
                                    "label-cols-sm": 11,
                                    "label-cols-lg": 11,
                                    "form-class": "text-right",
                                    v: _vm.$v.form
                                      .supplier_requirements_confirmed
                                      .supplier_reqs_c,
                                    label:
                                      "Подтверждаю, что соответствую требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                                    compact: "",
                                  },
                                  model: {
                                    value:
                                      _vm.form.supplier_requirements_confirmed
                                        .supplier_reqs_c,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form
                                          .supplier_requirements_confirmed,
                                        "supplier_reqs_c",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.supplier_requirements_confirmed.supplier_reqs_c",
                                  },
                                })
                              : _vm._e(),
                            _vm.purchase.supplier_requirements
                              .supplier_reqs_sonko
                              ? _c("form-row-edit-checkbox", {
                                  attrs: {
                                    "label-cols-sm": 11,
                                    "label-cols-lg": 11,
                                    "form-class": "text-right",
                                    v: _vm.$v.form
                                      .supplier_requirements_confirmed
                                      .supplier_reqs_sonko,
                                    label:
                                      "Подтверждаю, организация является социально ориентированной некоммерческой организацией (СОНКО)",
                                    compact: "",
                                  },
                                  model: {
                                    value:
                                      _vm.form.supplier_requirements_confirmed
                                        .supplier_reqs_sonko,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form
                                          .supplier_requirements_confirmed,
                                        "supplier_reqs_sonko",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.supplier_requirements_confirmed.supplier_reqs_sonko",
                                  },
                                })
                              : _vm._e(),
                            _vm.purchase.supplier_requirements
                              .has_additional_requirements
                              ? [
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "fs-14 grey-color my-2 mb-1",
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              "Подтверждаю соответствие дополнительным требованиям, приложив следующие документы:"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._l(
                                    _vm.purchase.supplier_requirements
                                      .additional_requirements,
                                    function (item, index) {
                                      return _c(
                                        "form-row-single-line-document-upload",
                                        {
                                          key: `additional_requirement_${index}`,
                                          attrs: {
                                            "label-cols-lg": 4,
                                            title: `${index + 1}. ${
                                              item.description
                                            } (причина: ${item.reason})`,
                                            v: _vm.$v.form
                                              .supplier_requirements_confirmed
                                              .additional_requirements.$each[
                                              index
                                            ].attachment,
                                            compact: "",
                                          },
                                          model: {
                                            value:
                                              _vm.form
                                                .supplier_requirements_confirmed
                                                .additional_requirements[index]
                                                .attachment,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form
                                                  .supplier_requirements_confirmed
                                                  .additional_requirements[
                                                  index
                                                ],
                                                "attachment",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.supplier_requirements_confirmed.additional_requirements[index].attachment",
                                          },
                                        }
                                      )
                                    }
                                  ),
                                ]
                              : _vm._e(),
                          ]
                        : [
                            _vm.purchase.supplier_requirements.supplier_reqs_a
                              ? [
                                  _c("text-row-boolean-text", {
                                    attrs: {
                                      "label-cols-sm": 11,
                                      "label-cols-lg": 11,
                                      "value-class": "text-right",
                                      label:
                                        "Подтверждаю, что соответствую требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                                      compact: "",
                                    },
                                    model: {
                                      value:
                                        _vm.form.supplier_requirements_confirmed
                                          .supplier_reqs_a,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form
                                            .supplier_requirements_confirmed,
                                          "supplier_reqs_a",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.supplier_requirements_confirmed.supplier_reqs_a",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-row",
                                      staticStyle: {
                                        "word-break": "break-all",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "fs-14 grey-color my-1",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                "Подтверждаю, что соответствую следующим требованиям"
                                              ),
                                            ]),
                                            _vm._v(
                                              " - " +
                                                _vm._s(
                                                  _vm.purchase
                                                    .supplier_requirements
                                                    .supplier_reqs_a_details
                                                    .supplier_reqs_a_text
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "fs-14 grey-color mt-2 mb-1",
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              "Подтверждаю, что соответствую указанным требованиям, приложив следующие документы:"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._l(
                                    _vm.purchase.supplier_requirements
                                      .supplier_reqs_a_details
                                      .supplier_reqs_a_documents,
                                    function (item, index) {
                                      return _c("text-row-single-document", {
                                        key: `supplier_required_document_${index}`,
                                        attrs: {
                                          label: item.name,
                                          "label-cols-lg": 4,
                                          compact: "",
                                        },
                                        model: {
                                          value:
                                            _vm.form
                                              .supplier_requirements_confirmed
                                              .supplier_required_documents[
                                              index
                                            ].storedDocument,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form
                                                .supplier_requirements_confirmed
                                                .supplier_required_documents[
                                                index
                                              ],
                                              "storedDocument",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.supplier_requirements_confirmed.supplier_required_documents[index].storedDocument",
                                        },
                                      })
                                    }
                                  ),
                                ]
                              : _vm._e(),
                            _vm.purchase.supplier_requirements.supplier_reqs_b
                              ? _c("text-row-boolean-text", {
                                  attrs: {
                                    "label-cols-sm": 11,
                                    "label-cols-lg": 11,
                                    "value-class": "text-right",
                                    label:
                                      "Подтверждаю, что соответствую требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                                    compact: "",
                                  },
                                  model: {
                                    value:
                                      _vm.form.supplier_requirements_confirmed
                                        .supplier_reqs_b,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form
                                          .supplier_requirements_confirmed,
                                        "supplier_reqs_b",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.supplier_requirements_confirmed.supplier_reqs_b",
                                  },
                                })
                              : _vm._e(),
                            _vm.purchase.supplier_requirements.supplier_reqs_c
                              ? _c("text-row-boolean-text", {
                                  attrs: {
                                    "label-cols-sm": 11,
                                    "label-cols-lg": 11,
                                    "value-class": "text-right",
                                    label:
                                      "Подтверждаю, что соответствую требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                                    compact: "",
                                  },
                                  model: {
                                    value:
                                      _vm.form.supplier_requirements_confirmed
                                        .supplier_reqs_c,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form
                                          .supplier_requirements_confirmed,
                                        "supplier_reqs_c",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.supplier_requirements_confirmed.supplier_reqs_c",
                                  },
                                })
                              : _vm._e(),
                            _vm.purchase.supplier_requirements
                              .supplier_reqs_sonko
                              ? _c("text-row-boolean-text", {
                                  attrs: {
                                    "label-cols-sm": 11,
                                    "label-cols-lg": 11,
                                    "value-class": "text-right",
                                    label:
                                      "Подтверждаю, организация является социально ориентированной некоммерческой организацией (СОНКО)",
                                    compact: "",
                                  },
                                  model: {
                                    value:
                                      _vm.form.supplier_requirements_confirmed
                                        .supplier_reqs_sonko,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form
                                          .supplier_requirements_confirmed,
                                        "supplier_reqs_sonko",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.supplier_requirements_confirmed.supplier_reqs_sonko",
                                  },
                                })
                              : _vm._e(),
                            _vm.purchase.supplier_requirements
                              .has_additional_requirements
                              ? [
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "fs-14 grey-color my-2 mb-1",
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              "Подтверждаю соответствие дополнительным требованиям, приложив следующие документы:"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._l(
                                    _vm.purchase.supplier_requirements
                                      .additional_requirements,
                                    function (item, index) {
                                      return _c("text-row-single-document", {
                                        key: `additional_requirement_${index}`,
                                        attrs: {
                                          "label-cols-lg": 4,
                                          label: `${index + 1}. ${
                                            item.description
                                          } (причина: ${item.reason})`,
                                          compact: "",
                                        },
                                        model: {
                                          value:
                                            _vm.form
                                              .supplier_requirements_confirmed
                                              .additional_requirements[index]
                                              .attachment,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form
                                                .supplier_requirements_confirmed
                                                .additional_requirements[index],
                                              "attachment",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.supplier_requirements_confirmed.additional_requirements[index].attachment",
                                        },
                                      })
                                    }
                                  ),
                                ]
                              : _vm._e(),
                          ],
                    ],
                    2
                  ),
                  _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "system_link-style fs-16" },
                                [_vm._v("XML")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      !_vm.isSignedXml
                        ? _c("b-form-textarea", {
                            staticClass: "text-monospace fs-12",
                            attrs: {
                              disabled: "",
                              rows: "20",
                              "no-resize": "",
                              "no-auto-shrink": "",
                              wrap: "off",
                            },
                            model: {
                              value: _vm.formXml,
                              callback: function ($$v) {
                                _vm.formXml = $$v
                              },
                              expression: "formXml",
                            },
                          })
                        : _c("b-form-textarea", {
                            staticClass: "text-monospace fs-12",
                            attrs: {
                              disabled: "",
                              rows: "20",
                              "no-resize": "",
                              "no-auto-shrink": "",
                              wrap: "off",
                            },
                            model: {
                              value: _vm.signedFormXml,
                              callback: function ($$v) {
                                _vm.signedFormXml = $$v
                              },
                              expression: "signedFormXml",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "w-100 px-3",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer",
            },
            [
              _c("text-row", {
                attrs: {
                  compact: "",
                  label: "Сертификат",
                  value: _vm.certificate?.subjectName,
                },
              }),
              _c(
                "b-form-invalid-feedback",
                { staticClass: "fs-14", attrs: { state: !_vm.$v.$invalid } },
                [
                  _vm._v(
                    'Невозможно подписать и сохранить контракт. Пожалуйста, заполните раздел "Требования к участникам закупки".'
                  ),
                ]
              ),
              _c(
                "b-button",
                {
                  staticClass: "mr-2 text-uppercase",
                  attrs: {
                    disabled: _vm.isDataSending,
                    variant: "custom-outline-secondary",
                  },
                  on: { click: _vm.cancelSignModal },
                },
                [_vm._v("Отмена")]
              ),
              !_vm.isSignedXml
                ? _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isSigningXml,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase",
                          attrs: {
                            disabled: !_vm.certificate || _vm.$v.$invalid,
                            variant: "custom-green",
                          },
                          on: { click: _vm.signForm },
                        },
                        [_vm._v("Подписать")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase",
                          attrs: {
                            disabled: !_vm.certificate,
                            variant: "custom-green",
                          },
                          on: { click: _vm.sendData },
                        },
                        [_vm._v("Отправить")]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }